import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, TextImageSection, TextBlock, ImageBlock } from '../components/InfoSection/InfoElements'

import img from '../images/nowe/wsparcie2.png';
import img2 from '../images/nowe/dowolnie(2).png';



const Opinie = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                  <div>
                    <TextImageSection>
                                      <ImageBlock>
                    <img src={img} alt="Atenida" />
                </ImageBlock>
                <TextBlock>
<h1>Wsparcie — holistyczny towarzysz w procesie przejścia przez stratę</h1>
                    <p>
                      W obliczu straty wielu ludzi kieruje się natychmiast ku zapomnieniu i odrzuceniu tego, co się wydarzyło, albo ku standardowej terapii. I słusznie — to bardzo ważna przestrzeń uzdrawiania.
                    </p>
                    <p>
                      Natomiast zauważyłam, że często pomija się aspekt rozwoju sprawczości, zasobów wewnętrznych i konkretnej pracy nad odbudową mentalnego dobrostanu. 
                    </p>
                    <p>
                      W moim prawie dziesięcioletnim doświadczeniu pracy z osobami po stracie, a szczególnie w czteroletnim doświadczeniu coachingowym, widzę wyraźnie, że odbudowanie poczucia sprawczości jest kluczowym punktem zwrotnym. Bez niego terapia może pomagać w przepracowaniu bólu, ale pozostaje niedokończona — bo nie daje fundamentu do ruszenia dalej w życie z odnowioną wiarą w siebie. 
                    </p>
                </TextBlock>

    </TextImageSection>
                    
                    <hr></hr>
                    <h2>Coaching kognitywny – odbudowa wewnętrznego steru </h2>
                    <p>
                      Coaching kognitywny łączy narzędzia coachingowe z psychologią poznawczą i pracą nad przekonaniami. W praktyce oznacza to:
                    </p>
                    <ul>
                      <li>
                        rozpoznawanie i transformowanie ograniczających wzorców myślowych, 
                      </li>
                      <li>
                        budowanie nowych, wspierających narracji, 
                      </li>
                      <li>
                        stosowanie technik takich jak reframing, wizualizacje, praca z metaforą, strategie radzenia sobie ze stresem,
                      </li>
                      <li>
                        tworzenie nowych ścieżek myślenia i działania, które wzmacniają poczucie sprawczości. 
                      </li>
                    </ul>
                    <p>W kontekście straty coaching pozwala: </p>
                    <ol>
                      <li>
                        Rozpoznać i nazwać destrukcyjne myśli typu „nic już nie ma sensu”,
                      </li>
                      <li>
                        Przeformułować je w kierunku wspierających przekonań i małych kroków ku życiu, 
                      </li>
                      <li>
                        Wzmacniać nowe perspektywy poprzez praktyczne ćwiczenia, zadania i codzienne rytuały. 
                      </li>
                    </ol>
                    <p>Dzięki temu osoba odzyskuje poczucie wewnętrznego steru — fundament, na którym można budować dalsze etapy żałoby i nowej tożsamości.</p>
                    <hr>
                    </hr>
                    <h2>Socjoterapia — emocje, relacje, wspólnota</h2>
                    <p>Strata dotyka nie tylko jednostki, ale także jej otoczenie. Dlatego włączam elementy socjoterapii, które pozwalają:</p>
                    <ul>
                      <li>
                        pracować głęboko z emocjami, 
                      </li>
                      <li>
                        przyglądać się relacjom w rodzinie i systemie, 
                      </li>
                      <li>
                        korzystać z mocy grupy i wspólnoty, 
                      </li>
                      <li>
                        wyrażać to, co często niewyrażalne — poprzez ruch, obraz, rytuał czy pracę z ciałem.
                      </li>
                    </ul>
                    <p>Socjoterapia daje przestrzeń na integrację emocji, odbudowę więzi i uczenie się nowych sposobów radzenia sobie z doświadczeniem straty — zarówno w wymiarze indywidualnym, jak i rodzinnym. </p>
                    <hr></hr>
                    <TextImageSection>
                <TextBlock>
<h2>Jak łączy się to z ceremoniami?</h2>
                    <p>Ceremonie, które tworzę, stają się mostem między zewnętrznym wydarzeniem pożegnania a wewnętrznym procesem transformacji. </p>
                    <p>Dzięki coachingowi i socjoterapii: </p>
                    <ul>
                      <li>
                        ceremonia staje się naturalną częścią procesu uzdrawiania, a nie tylko jednorazowym wydarzeniem, 
                      </li>
                      <li>
                        osoba przychodzi do niej z większą świadomością, narzędziami i poczuciem bezpieczeństwa,
                      </li>
                      <li>
                        rytuał przejścia rezonuje nie tylko w przestrzeni symbolicznej, ale też w realnym doświadczeniu osoby i jej bliskich. 
                      </li>
                    </ul>
                    <p>To właśnie holistyczne połączenie sprawia, że ceremonia zyskuje głębię i realnie wspiera w procesie odnajdywania nowej drogi po stracie. </p>
                </TextBlock>
                <ImageBlock>
                    <img src={img2} alt="Atenida" />
                </ImageBlock>
    </TextImageSection>



                    
                    <hr></hr>
                    <h2>Formy pracy</h2>
                    <ul>
                      <li>
                        Sesje indywidualne – najczęściej online, co daje osobie komfort pracy we własnej przestrzeni. 
                      </li>
                      <li>
                        Sesje rodzinne – gdy proces dotyczy relacji i wspólnego przechodzenia przez stratę. 
                      </li>
                      <li>
                        Spotkania na żywo – możliwe w uzgodnionych przypadkach. 
                      </li>
                      <li>
                        Codzienne rytuały i praktyki – proste, indywidualnie dobrane, które wspierają proces także pomiędzy sesjami. 
                      </li>
                      <li>
                        Praca z ciałem, oddechem i uważnością – aby integrować emocje na poziomie somatycznym. 
                      </li>
                    </ul>
                    <hr></hr>
                    <h2>Bezpieczeństwo, opieka, zaufanie</h2>
                    <p>Moje podejście to opieka wielowymiarowa. Łączę doświadczenie mistrzyni ceremonii, coacha, socjoterapeutki i osoby pracującej z energią w ugruntowany, bezpieczny sposób. </p>
                    <p>Dzięki temu osoba, która do mnie trafia, otrzymuje poczucie, że jest zaopiekowana nie tylko od strony organizacyjnej ceremonii, ale także mentalnej, emocjonalnej i duchowej. </p>
                    <p>To wsparcie jest jak most — prowadzi od doświadczenia straty ku nowej przestrzeni życia, w której ból nie znika, ale transformuje się w siłę, sens i nowe źródła energii.</p>
                    <h2>Dodatkowa możliwość wsparcia </h2>
                    <p>Choć naturalnie wiele osób trafia do mnie w związku z przygotowaniem ceremonii, moje wsparcie nie ogranicza się wyłącznie do tego momentu. </p>
                    <p>Jeżeli Twoja ceremonia pożegnania z bliską osobą odbyła się już dawno, ale czujesz, że proces wciąż nie został domknięty, że emocje lub doświadczenia pozostały niezintegrowane — również możesz się do mnie zgłosić. </p>
                    <p>Prowadzę sesje wspierające dla osób, które:</p>
                    <ul>
                      <li>
                        czują, że wciąż noszą w sobie nierozwiązany ciężar, 
                      </li>
                      <li>
                        pragną odnaleźć spokój, sens i nową perspektywę, 
                      </li>
                      <li>
                        chcą zintegrować dawne doświadczenie i przejść dalej w poczuciu większej lekkości i wolności. 
                      </li>
                    </ul>
                    <p>Podczas takich spotkań korzystam z całego mojego doświadczenia oraz różnorodnych narzędzi — od coachingu kognitywnego, przez socjoterapię, po indywidualnie dobrane rytuały wspierające. </p>
                    <p>👉Wystarczy zakupić sesję w sklepie, a następnie wybrać dogodny termin w terminarzu online (link znajdziesz poniżej lub otrzymasz w wiadomości po zakupie). </p>
                  </div>
                </InfoWrapper>
    </InfoContainer3>
    <Footer />
    </>
  )
}

export default Opinie